import React from 'react'

//starting with capital letter will ensure this is treated as a component
const InvGridItemImageD = ({formObject, viewData, rowKey, imgHeight}) => {

    return (
        <div className="saras-cell">
            <ul style={{width:"200px"}}>
                {Object.values(viewData.childRows).map((row,index)=>(
                    <li key={index} style={{display:"inline-block",width:"50px",height:"50px"}}>
                        <a href={row.rowValues.itemImage.dataList.lsrc} target="_LargeImage">
                            <img alt={index} height={imgHeight || "100%"} width="100%" src={row.rowValues.itemImage.dataList.src} 
                                onError={e => { e.target.style.display = 'none'; }}
                            />
                        </a>
                    </li>
                ))
                }
            </ul>
        </div>
    );
}

export default InvGridItemImageD
